export const BLND_CD_NM = [
  {
    name: "Double Blind",
  },
  {
    name: "Open",
  },
  {
    name: "Partial Blind",
  },
  {
    name: "Single Blind",
  },
];

export const RNDM_ASSG_CD_NM = [
  {
    name: "Non-randomized",
  },
  {
    name: "Randomized",
  },
];

export const YN = [{ name: "Y" }, { name: "N" }];

export const CLNC_TEST_DTL_CD_NM = [
  { name: "가교시험" },
  { name: "국내" },
  { name: "다국가" },
];

export const DMINT_DIVS_CD_NM = [
  {
    name: "국내개발",
  },
  {
    name: "국외개발",
  },
];

export const CLST_PRPOS_CD_NM = [
  {
    name: "학술연구용",
  },
  { name: "허가용" },
];
export const CLINIC_STEP_NAME = [
  {
    name: "0상",
  },
  {
    name: "1/2상",
  },
  {
    name: "1/2a상",
  },
  {
    name: "1/3상",
  },
  {
    name: "1상",
  },
  {
    name: "1b상",
  },
  {
    name: "2/3상",
  },
  {
    name: "2상",
  },
  {
    name: "2a상",
  },
  {
    name: "2b/3상",
  },
  {
    name: "2b상",
  },
  {
    name: "3/4상",
  },
  {
    name: "3상",
  },
  {
    name: "3a상",
  },
  {
    name: "3b상",
  },
  {
    name: "4상",
  },
  {
    name: "생동",
  },
  {
    name: "연구자 임상시험",
  },
  {
    name: "연장",
  },
];

export const fields = [
  {
    dataField: "APPLY_ENTP_NAME",
    caption: "신청자",
    dataType: "string",
    width: 200,
  },
  {
    dataField: "RPRSV_NMP",
    caption: "임상시험 대표자",
    dataType: "string",
  },
  { dataField: "ADDR", caption: "임상시험 소재지", dataType: "string" },
  { dataField: "ORGN_DEV_BSSH_NM", caption: "원개발사", dataType: "string" },
  {
    dataField: "ORGN_DEV_NATN_CD_NM",
    caption: "원개발사 국가",
    dataType: "string",
  },
  {
    dataField: "HIST_REG_DT",
    caption: "최근(변경)승인일자",
    dataType: "date",
    width: 150,
    format: "yyyy-MM-dd",
  },
  {
    dataField: "APPROVAL_TIME",
    caption: "승인일",
    dataType: "date",
    width: 150,
    format: "yyyy-MM-dd",
  },
  { dataField: "LAB_NAME", caption: "실시기관", dataType: "string" },
  {
    dataField: "GOODS_NAME",
    caption: "제품명",
    dataType: "string",
    width: 200,
  },
  {
    dataField: "GNRL_CD_NM",
    caption: "성분명",
    dataType: "string",
  },

  {
    dataField: "CLINIC_EXAM_TITLE",
    caption: "시험제목",
    dataType: "string",
  },
  {
    dataField: "CLINIC_EXAM_ENG_TITLE",
    caption: "시험제목 (영문)",
    dataType: "string",
  },
  { dataField: "IVSGT_PURPS", caption: "목적", dataType: "string" },
  {
    dataField: "CLST_PRPOS_CD_NM",
    caption: "용도",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["학술연구용", "허가용"],
    },
  },
  {
    dataField: "DMINT_DIVS_CD_NM",
    caption: "국내/국외개발",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["국내개발", "국외개발"],
    },
  },
  {
    dataField: "CLNC_TEST_DTL_CD_NM",
    caption: "상세구분 (다국가)",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["가교시험", "국내", "대국가"],
    },
  },
  {
    dataField: "TRGT_DISS_CD_NM",
    caption: "대상질환",
    dataType: "string",
  },
  {
    dataField: "TRGT_DISS_DTL_CD_NM",
    caption: "대상질환 상세",
    dataType: "string",
  },
  {
    dataField: "TRGT_DISS_DTL_ETC",
    caption: "대상질환 기타 직접입력",
    dataType: "string",
  },
  {
    dataField: "TRGT_DISS_NM",
    caption: "대상질환명 (적응증)",
    dataType: "string",
  },
  {
    dataField: "DMST_PRMSN_YN",
    caption: "국내허가여부",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["Y", "N"],
    },
  },
  {
    dataField: "COMP_DRUG_YN",
    caption: "활성대조약여부",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["Y", "N"],
    },
  },
  {
    dataField: "FRST_INDV_TRGT_IVSGT_YN",
    caption: "최초사람대상여부",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["Y", "N"],
    },
  },
  {
    dataField: "CPDR_YN",
    caption: "대조약여부",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["Y", "N"],
    },
  },
  {
    dataField: "PLCB_YN",
    caption: "위약여부",
    dataType: "string",
    width: 150,
    lookup: {
      dataSource: ["Y", "N"],
    },
  },
  { dataField: "COMP_DRUG_NM", caption: "대조약제품명", dataType: "string" },
  { dataField: "SHAPE_CD", caption: "제형", dataType: "string" },
  {
    dataField: "CLINIC_STEP_NAME",
    caption: "단계",
    datatype: "string",
    width: 150,
    lookup: {
      dataSource: [
        "0상",
        "1/2상",
        "1/2a상",
        "1/3상",
        "1상",
        "1b상",
        "2/3상",
        "2상",
        "2a상",
        "2b/3상",
        "2b상",
        "3/4상",
        "3상",
        "3a상",
        "3b상",
        "4상",
        "생동",
        "연구자 임상시험",
        "연장",
      ],
    },
  },
  {
    dataField: "CLINIC_TYPE_CD_NM",
    caption: "임상시험형태",
    type: "string",
  },
  {
    dataField: "CLINICAL_PERIOD",
    caption: "기간",
    type: "string",
  },
  {
    dataField: "TESTEE_CNT_INFO",
    caption: "목표대상자수 (국내 대상자수)",
    type: "string",
  },
  {
    dataField: "RNDM_ASSG_CD_NM",
    caption: "무작위배정여부",
    type: "string",
    width: 150,
    lookup: {
      dataSource: ["Non-randomized", "Randomized"],
    },
  },
  {
    dataField: "BLND_CD_NM",
    caption: "눈가림종류",
    type: "string",
    width: 150,
    lookup: {
      dataSource: ["Double Blind", "Open", "Partial Blind", "Single Blind"],
    },
  },
  {
    dataField: "ARBTR_GRP_NUM",
    caption: "중재군수",
    type: "string",
  },
  {
    dataField: "CLST_BGNG_DT",
    caption: "최초 시험대상자 선정일",
    dataType: "date",
    format: "yyyy-MM-dd",
    width: 150,
  },
  {
    dataField: "LAST_TRGTER_SLCTN_DT",
    caption: "최종 시험대상자 선정일",
    dataType: "date",
    format: "yyyy-MM-dd",
    width: 150,
  },
  {
    dataField: "CLST_END_DT",
    caption: "최종 시험대상자 관찰 종료일",
    dataType: "date",
    format: "yyyy-MM-dd",
    width: 150,
  },
  {
    dataField: "RESULT_REPORT_SUBMIT_DT",
    caption: "결과보고 제출일",
    dataType: "date",
    format: "yyyy-MM-dd",
    width: 150,
  },
  {
    dataField: "PRIM_EVL_VAR",
    caption: "1차 유효성 평가변수",
    type: "string",
  },
  {
    dataField: "SCND_EVL_VAR",
    caption: "2차 유효성 평가변수",
    type: "string",
  },
  {
    dataField: "DOSAGE_TERM_TS",
    caption: "투여기간",
    type: "string",
  },
  {
    dataField: "CLST_MTH_INFO",
    caption: "투여방법",
    type: "string",
  },
  {
    dataField: "STATUS",
    caption: "진행현황",
    type: "string",
  },
  {
    dataField: "HMPG_ADDR",
    caption: "모집공고 확인 홈페이지 주소",
    dataType: "string",
  },
];

export const data = [
  {
    APPLY_ENTP_NAME: "(사)삼성생명공익재단 삼성서울병원",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 0,
    "1b상": 0,
    "2/3상": 0,
    "2상": 0,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 0,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 0,
    "연구자 임상시험": 1,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(사)한국의약품수출입협회",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 0,
    "1b상": 0,
    "2/3상": 0,
    "2상": 0,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 0,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 1,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(유)인큐어텍",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 0,
    "1b상": 0,
    "2/3상": 0,
    "2상": 0,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 1,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 0,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(유)한국비엠에스제약",
    "0상": 0,
    "1/2상": 3,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 3,
    "1b상": 0,
    "2/3상": 0,
    "2상": 14,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 3,
    "3/4상": 0,
    "3상": 31,
    "3a상": 0,
    "3b상": 4,
    "4상": 2,
    생동: 0,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(유)한풍제약",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 3,
    "1b상": 0,
    "2/3상": 0,
    "2상": 2,
    "2a상": 3,
    "2b/3상": 0,
    "2b상": 2,
    "3/4상": 0,
    "3상": 0,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 4,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(주) 메드팩토",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 2,
    "1/3상": 0,
    "1상": 1,
    "1b상": 0,
    "2/3상": 0,
    "2상": 2,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 0,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 0,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(주) 메티메디제약",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 0,
    "1/3상": 0,
    "1상": 1,
    "1b상": 0,
    "2/3상": 0,
    "2상": 0,
    "2a상": 1,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 0,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 0,
    "연구자 임상시험": 0,
    연장: 0,
  },
  {
    APPLY_ENTP_NAME: "(주) 비보존헬스케어",
    "0상": 0,
    "1/2상": 0,
    "1/2a상": 1,
    "1/3상": 0,
    "1상": 0,
    "1b상": 0,
    "2/3상": 0,
    "2상": 0,
    "2a상": 0,
    "2b/3상": 0,
    "2b상": 0,
    "3/4상": 0,
    "3상": 1,
    "3a상": 0,
    "3b상": 0,
    "4상": 0,
    생동: 0,
    "연구자 임상시험": 0,
    연장: 0,
  },
];

export const LAB_NAME = [
  {
    LAB_NAME: "(학교법인)인제대학교부산백병원",
  },
  {
    LAB_NAME: "가톨릭대학교 여의도성모병원",
  },
  {
    LAB_NAME: "가톨릭대학교의정부성모병원",
  },
  {
    LAB_NAME: "분당서울대학교병원",
  },
  {
    LAB_NAME: "한림대학교부속 춘천성심병원",
  },
];
